/* eslint-disable react-hooks/exhaustive-deps */
import Axios from "axios";
import React, { useEffect, useState } from "react";
import { ReactComponent as Right } from "../../static/arrowRight.svg";
import check from "../../static/check.png";
import "./game.scss";

export default function Gdpr({ next, closeKeyboard }) {
  const [accepted, setAccepted] = useState(false);
  const [gdpr, setGDPR] = useState("");

  useEffect(() => {
    closeKeyboard();
    fetchGdprHTML();
  }, []);

  const handleClickAccepted = (event) => {
    setAccepted(!accepted);
  };

  const fetchGdprHTML = async () => {
    await Axios.get("/1.0.0/game/gdpr").then((response) => {
      /*  console.log(response.data); */
      setGDPR(response.data);
    });
  };

  return (
    <div>
      <div className="gdpr-paragraph">
        {/* Bacon ipsum dolor amet sirloin pastrami tri-tip salami. Hamburger
        drumstick ball tip swine boudin. Turducken hamburger biltong shank.
        Short ribs prosciutto chuck ham hock tri-tip flank pork tenderloin. */}
        <div dangerouslySetInnerHTML={{ __html: gdpr }} />
      </div>
      <div
        style={{ display: "flex", justifyContent: "center", padding: "1em" }}
      >
        <div
          style={{ marginRight: "0.5em" }}
          className={accepted ? "accept-text accept-text-green" : "accept-text"}
          onClick={handleClickAccepted}
        >
          Elfogadom
        </div>
        <div style={{ marginLeft: "0.5em" }}>
          {accepted === true ? (
            <img
              alt="check"
              src={check}
              className="gdpr-check"
              onClick={handleClickAccepted}
            />
          ) : (
            <span className="empty-circle" onClick={handleClickAccepted} />
          )}
        </div>
      </div>
      <div>
        <button
          onClick={next}
          disabled={!accepted}
          className={
            accepted ? "gdpr-next-button" : "gdpr-next-button disabled-button"
          }
        >
          Következő <Right className="gdpr-arrow-icon" />
        </button>
      </div>
    </div>
  );
}
